import { useCookie } from '#app';

export const getUserGuid = (brand = import.meta.env.VITE_ENTRY_POINT) => {
  const cookieName = brand === 'bcom' ? 'bloomingdales_online_guid' : 'macys_online_guid';
  return useCookie(cookieName).value;
};

export default {
  getUserGuid,
};
